import { observer } from 'mobx-react-lite';
import type { TypographyPanelProps, TypographyPanelValueProps } from './types';
import TypographyPanel from './TypographyPanel';

export type { TypographyPanelProps, TypographyPanelValueProps };
export default observer(TypographyPanel); // MANUAL OVERRIDE
